
import ProductType from './productType'; 

class Item {
  constructor(productType, quantityS = 0, quantityM = 0, quantityL = 0) {
    if (!(productType instanceof ProductType)) {
      throw new Error('productType deve essere un\'istanza della classe ProductType');
    }

    this.productType = productType;  // Dovrebbe essere un'istanza della classe ProductType
    this.quantityS = quantityS;      // Quantità della taglia S
    this.quantityM = quantityM;      // Quantità della taglia M
    this.quantityL = quantityL;      // Quantità della taglia L
  }
  getProductType() {
    return this.productType;
  }

}

export default Item;
